import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  root: {},
  cancelButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.default + "!important"
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/SendTextDialog/styles.js